export default __webpack_public_path__ + "static/media/locked.08718a91.svg";